export default __webpack_public_path__ + "static/media/Users icon color 0285A1.484a638c.svg";